<div
  class="gw-w-full gw-max-w-3xl gw-mx-auto gw-max-h-[70vh] gw-overflow-y-auto"
>
  <form
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit()"
    class="gw-space-y-4 gw-p-x-large"
  >
    <p class="gw-text-text-primary gw-text-base">
      {{ 'features.settings.parameters.antifraud.description' | translate }}
    </p>
    <section
      *ngFor="let p of providers"
      [formGroupName]="p"
      class="gw-border gw-border-border-normal gw-rounded-lg gw-p-4 gw-space-y-3"
    >
      <h3 class="gw-text-sm gw-font-medium gw-text-text-primary gw-uppercase">
        {{ p }}
      </h3>
      <label class="gw-flex gw-items-center gw-gap-2 gw-cursor-pointer">
        <input
          type="checkbox"
          formControlName="enabled"
          class="gw-w-5 gw-h-5"
        />
        <span class="gw-text-text-secondary">{{
          'features.settings.parameters.antifraud.enabled' | translate
        }}</span>
      </label>
      <gatewee-input-v2
        [form]="providerGroup(p)"
        controlName="publicKey"
        [label]="
          'features.settings.parameters.antifraud.publicKey.label' | translate
        "
        [id]="'antifraud-pk-' + p"
        type="text"
      ></gatewee-input-v2>
      <gatewee-input-v2
        [form]="providerGroup(p)"
        controlName="deviceFingerprintOrgId"
        [label]="
          'features.settings.parameters.antifraud.deviceFingerprintOrgId.label'
            | translate
        "
        [info]="
          'features.settings.parameters.antifraud.deviceFingerprintOrgId.hint'
            | translate
        "
        [id]="'antifraud-dfo-' + p"
        type="text"
      ></gatewee-input-v2>
      <gatewee-input-v2
        [form]="providerGroup(p)"
        controlName="deviceFingerprintSessionPrefix"
        [label]="
          'features.settings.parameters.antifraud.deviceFingerprintSessionPrefix.label'
            | translate
        "
        [info]="
          'features.settings.parameters.antifraud.deviceFingerprintSessionPrefix.hint'
            | translate
        "
        [id]="'antifraud-dfsp-' + p"
        type="text"
      ></gatewee-input-v2>
    </section>
    <div class="gw-flex gw-justify-end gw-gap-3 gw-pt-4">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting"
      ></gatewee-button>
    </div>
  </form>
</div>
